import { PagedRequestDto } from './../paged-request.model';
export interface CorporateRolesParameters extends PagedRequestDto {
  corporationId: string;
  isActive?: boolean;
  isProtected?: boolean;
}
